<template>
  <div class="container">
    <div class="loading" v-show="loading">
      <Loading />
    </div>

    <AlertError v-show="!showData && !loading" />

    <section v-show="showData">
      <div class="head-data">
        <h6 class="title">
          Dotación efectiva año {{ year }} por tipo de relación laboral
        </h6>
      </div>
      <Graphics
        :labels="relacionLaboralGenero ? relacionLaboralGenero.labels : null"
        :content="relacionLaboralGenero ? relacionLaboralGenero.data : null"
        :highestValue="
          relacionLaboralGenero ? relacionLaboralGenero.highestValue : null
        "
      />
    </section>
    <section v-show="showData">
      <div class="head-data">
        <h6 class="title">
          Dotación efectiva año {{ year }} por tipo estamento y género
        </h6>
      </div>
      <GraphicsTwo
        :labels="estamentoGenero ? estamentoGenero.labels : null"
        :data="estamentoGenero ? estamentoGenero.data : null"
        :highestValue="estamentoGenero ? estamentoGenero.highestValue : null"
      />
    </section>
    <section v-show="showData">
      <div class="head-data">
        <h6 class="title">
          Dotación efectiva año {{ year }} por tipo grupos de edad
        </h6>
      </div>
      <GraphicsEdadGenero
        :labels="gruposEdad ? gruposEdad.labels : null"
        :data="gruposEdad ? gruposEdad.data : null"
        :highestValue="gruposEdad ? gruposEdad.highestValue : null"
      />
    </section>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Graphics from "../../../components/graphics/Graphics.vue";
import AlertError from "../../../components/error/AlertError.vue";
import GraphicsTwo from "../../../components/graphics/GraphicsTwo.vue";
import GraphicsEdadGenero from "../../../components/graphics/GraphicsEdadGenero.vue";
import Loading from "../../../components/tools/Loading.vue";
// import { maxData } from "../../../components/tools/utils";
import axios from "axios";
export default {
  components: {
    Graphics,
    GraphicsTwo,
    GraphicsEdadGenero,
    AlertError,
    Loading,
  },
  data() {
    return {
      relacionLaboralGenero: null,
      estamentoGenero: null,
      gruposEdad: null,
      showData: false,
      loading: true,
    };
  },
  computed: {
    ...mapGetters(["year"]),
  },
  methods: {
    async constructRelLabData() {
      try {
        let idService = this.$route.params.id;
        const getAnexoServicio = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/anexos/anexo/public_list/?servicio=${idService}&anexo=2`
        );

        if (getAnexoServicio.data.length == 0) {
          this.showData = false;
          this.loading = false;
        } else {
          let toBuildData =
            getAnexoServicio.data[0].datos.indicadores[this.year];

          const relLabGen = toBuildData[6];
          const gruposEdad = toBuildData[7];
          const estGen = toBuildData[8];
          this.relacionLaboralGenero = {
            labels: Object.keys(relLabGen),
            data: {
              h: Object.keys(relLabGen).map((i) =>
                relLabGen[i].H ? parseInt(Object.keys(relLabGen[i].H)[0]) : 0
              ),
              m: Object.keys(relLabGen).map((i) =>
                relLabGen[i].M ? parseInt(Object.keys(relLabGen[i].M)[0]) : 0
              ),
              perc: {
                h: Object.keys(relLabGen).map((i) =>
                  relLabGen[i].H
                    ? relLabGen[i].H[Object.keys(relLabGen[i].H)]
                    : 0
                ),
                m: Object.keys(relLabGen).map((i) =>
                  relLabGen[i].M
                    ? relLabGen[i].M[Object.keys(relLabGen[i].M)]
                    : 0
                ),
              },
            },
          };
          this.sortDataGenero(this.relacionLaboralGenero);

          this.gruposEdad = {
            labels: Object.keys(gruposEdad),
            data: {
              h: Object.keys(gruposEdad).map((i) =>
                gruposEdad[i].H ? parseInt(Object.keys(gruposEdad[i].H)[0]) : 0
              ),
              m: Object.keys(gruposEdad).map((i) =>
                gruposEdad[i].M ? parseInt(Object.keys(gruposEdad[i].M)[0]) : 0
              ),
              perc: {
                h: Object.keys(gruposEdad).map((i) =>
                  gruposEdad[i].H
                    ? gruposEdad[i].H[Object.keys(gruposEdad[i].H)]
                    : 0
                ),
                m: Object.keys(gruposEdad).map((i) =>
                  gruposEdad[i].M
                    ? gruposEdad[i].M[Object.keys(gruposEdad[i].M)]
                    : 0
                ),
              },
            },
          };

          var first = this.gruposEdad.labels.shift();
          this.gruposEdad.labels.push(first);
          first = this.gruposEdad.data.h.shift();
          this.gruposEdad.data.h.push(first);
          first = this.gruposEdad.data.m.shift();
          this.gruposEdad.data.m.push(first);
          first = this.gruposEdad.data.perc.h.shift();
          this.gruposEdad.data.perc.h.push(first);
          first = this.gruposEdad.data.perc.m.shift();
          this.gruposEdad.data.perc.m.push(first);

          this.estamentoGenero = {
            labels: Object.keys(estGen),
            data: {
              h: Object.keys(estGen).map((i) =>
                estGen[i].H ? parseInt(Object.keys(estGen[i].H)[0]) : 0
              ),
              m: Object.keys(estGen).map((i) =>
                estGen[i].M ? parseInt(Object.keys(estGen[i].M)[0]) : 0
              ),
              perc: {
                h: Object.keys(estGen).map((i) =>
                  estGen[i].H ? estGen[i].H[Object.keys(estGen[i].H)] : 0
                ),
                m: Object.keys(estGen).map((i) =>
                  estGen[i].M ? estGen[i].M[Object.keys(estGen[i].M)] : 0
                ),
              },
            },
          };
          this.sortDataGenero(this.estamentoGenero);

          // this.highestData();
          setTimeout(() => {
            this.showData = true;
            this.loading = false;
          }, 1000);
        }
      } catch (error) {
        this.showData = false;
        this.loading = false;
        console.log(error);
      }
    },
    sortDataGenero: function(toSort) {
      var data = toSort.data;
      var labels = toSort.labels;
      var l = labels.length,
        dataTemp,
        labelsTemp;
      for (let i = 0; i < l; i++) {
        for (let j = 0; j < l - 1 - i; j++) {
          if (data.h[j] < data.h[j + 1] && data.m[j] < data.m[j + 1]) {
            labelsTemp = labels[j];
            labels[j] = labels[j + 1];
            labels[j + 1] = labelsTemp;

            dataTemp = data.h[j];
            data.h[j] = data.h[j + 1];
            data.h[j + 1] = dataTemp;

            dataTemp = data.m[j];
            data.m[j] = data.m[j + 1];
            data.m[j + 1] = dataTemp;

            dataTemp = data.perc.h[j];
            data.perc.h[j] = data.perc.h[j + 1];
            data.perc.h[j + 1] = dataTemp;

            dataTemp = data.perc.m[j];
            data.perc.m[j] = data.perc.m[j + 1];
            data.perc.m[j + 1] = dataTemp;
          }
        }
      }
    },
    // highestData: function() {
    //   let relacionLaboralGeneroHighest,
    //     gruposEdadHighest,
    //     estamentoGeneroHighest;
    //   if (
    //     this.relacionLaboralGenero.data.h[0] >
    //     this.relacionLaboralGenero.data.m[0]
    //   ) {
    //     relacionLaboralGeneroHighest = this.relacionLaboralGenero.data.h[0];
    //   } else {
    //     relacionLaboralGeneroHighest = this.relacionLaboralGenero.data.m[0];
    //   }
    //   this.relacionLaboralGenero.highestValue = maxData(
    //     relacionLaboralGeneroHighest
    //   );

    //   if (this.gruposEdad.data.h[0] > this.gruposEdad.data.m[0]) {
    //     gruposEdadHighest = this.gruposEdad.data.h[0];
    //   } else {
    //     gruposEdadHighest = this.gruposEdad.data.m[0];
    //   }
    //   this.gruposEdad.highestValue = maxData(gruposEdadHighest);

    //   if (this.estamentoGenero.data.h[0] > this.estamentoGenero.data.m[0]) {
    //     estamentoGeneroHighest = this.estamentoGenero.data.h[0];
    //   } else {
    //     estamentoGeneroHighest = this.estamentoGenero.data.m[0];
    //   }
    //   this.estamentoGenero.highestValue = maxData(estamentoGeneroHighest);
    // },
  },
  watch: {
    year: function() {
      this.constructRelLabData();
    },
    showData: function() {
      this.constructRelLabData();
    },
  },
  mounted() {
    this.constructRelLabData();
  },
};
</script>
<style scoped>
.head-data {
  background-color: #cfcccc;
}
.title {
  padding: 1rem;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3rem 0;
}
</style>
